var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.9,436.4V163.6c0-1,.2-2,.5-2.9l-37.2,6.5c-2.2.4-3.7,2.2-3.7,4.4v264.8c0,2.5,2,4.5,4.5,4.5h37.1c-.8-1.3-1.2-2.9-1.2-4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M511,154.6H133.9s0,0,0,0c-1,0-2,.2-3,.5l-43.5,7.6c-4.3.8-7.4,4.5-7.4,8.8v264.8c0,5,4,9,9,9h422c5,0,9-4,9-9V163.6c0-5-4-9-9-9ZM511,440.9H133.9c-2.5,0-4.5-2-4.5-4.5v-31.4h386.1v31.4c0,2.5-2,4.5-4.5,4.5ZM515.5,265.8v134.7H129.4v-236.8c0-2.5,2-4.5,4.5-4.5h377.1c2.5,0,4.5,2,4.5,4.5v102.1ZM84.5,436.4V171.6c0-2.2,1.6-4,3.7-4.4l37.2-6.5c-.3.9-.5,1.9-.5,2.9v272.8c0,1.6.4,3.2,1.2,4.5h-37.1c-2.5,0-4.5-2-4.5-4.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.3,179.3c-55.7,0-101,45.3-101,101s45.3,101,101,101,101-45.3,101-101-45.3-101-101-101ZM362.9,280.4c0,53.2-43.3,96.5-96.5,96.5s-96.5-43.3-96.5-96.5,43.3-96.5,96.5-96.5,96.5,43.3,96.5,96.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M266.3,207.4c-40.2,0-73,32.7-73,73s32.7,73,73,73,73-32.7,73-73-32.7-73-73-73ZM334.8,280.4c0,37.8-30.7,68.5-68.5,68.5s-68.5-30.7-68.5-68.5,30.7-68.5,68.5-68.5,68.5,30.7,68.5,68.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M266.3,257.9c-12.4,0-22.4,10.1-22.4,22.4s10.1,22.4,22.4,22.4,22.4-10.1,22.4-22.4-10.1-22.4-22.4-22.4ZM284.3,280.4c0,9.9-8.1,18-18,18s-18-8.1-18-18,8.1-18,18-18,18,8.1,18,18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatPump);
export default __webpack_public_path__ + "static/media/heat-pump.06aba787d27e8d5b1ca951f507e507ba.svg";
export { ForwardRef as ReactComponent };